package cc.easyandroid.easycompose.core.statekeeper

import kotlinx.serialization.SerializationStrategy

internal actual fun <T> T.serialize(strategy: SerializationStrategy<T>): ByteArray =
    easyComposeJson.encodeToString(serializer = strategy, value = this).encodeToByteArray()

